import React from 'react';
import './submenu.component.scss';
import { NavLink } from 'react-router-dom';
import { Button, Menu, MenuItem, MenuProps, styled } from '@mui/material';
import { CONSTANTS } from '../../constants/constants';
import { ItensMenuModel } from '../../models/menu.model';

export type SubMenuComponentProps = {
  itemMenu: ItensMenuModel;
  subMenus: ItensMenuModel[];
  cor_texto_menu: string;
  cor_texto_submenu: string;
  cor_fundo_submenu: string;
  clickItemSubmenu: () => void;
}

function SubMenuComponent(props: SubMenuComponentProps) {

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    props.clickItemSubmenu();
  };

  const Submenu = styled(Menu)<MenuProps>(({ theme }) => ({
    // width: 300,
    // color: 'red',
    '& .MuiList-root': {
      backgroundColor: props.cor_fundo_submenu ? props.cor_fundo_submenu : "#fff"
    }
  }));

  return (
    <>
      <NavLink exact={true} to={props.itemMenu.sem_acao ? '#' : CONSTANTS.TIPO_MENU.NOVA_PAGINA + props.itemMenu.id_do_componente} activeClassName="active">
        <Button
          style={{
            color: props.cor_texto_menu ? props.cor_texto_menu : '#fff'
          }}
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >{props.itemMenu.nome}</Button>
      </NavLink>
      <Submenu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {
          props.subMenus.map(itemSubmenu => (
            <NavLink to={CONSTANTS.TIPO_MENU.NOVA_PAGINA + itemSubmenu.id_do_componente}>
              <Button
                onClick={handleClose}
                style={{
                  color: props.cor_texto_submenu ? props.cor_texto_submenu : '#000'
                }}
              >{itemSubmenu.nome}</Button>
            </NavLink>
          ))
        }
      </Submenu>
    </>
  );
}

export default SubMenuComponent;
